/**
 * Where the API lives.
 *
 * Shared because two callers need it and they must not drift: the axios client,
 * and `revokeRefreshToken`, which deliberately uses plain `fetch` because
 * `authStore` cannot import the client — the client imports the store. The URL
 * itself carries none of that cycle, so it belongs in one place.
 */
export const API_BASE_URL = import.meta.env.VITE_API_URL || "/api/v1";
